import {URL_STATICS_IMAGES} from '../base.js'
import {PROFESSIONALS_PATH_PATTERN, PTA_PATH_PATTERN, SECOND_HAND_PATH_PATTERN} from './page.js'

export const MARKET_PLAYERS_CARD_DATA = {
  private: {
    media: {
      src: `${URL_STATICS_IMAGES}market-player-private@2x.jpg`,
      alt: 'publisher-particular'
    },
    text: {
      title: 'CARD_MARKET_PLAYERS_PRIVATE_TITLE',
      description: 'CARD_MARKET_PLAYERS_PRIVATE_TEXT'
    },
    link: PTA_PATH_PATTERN
  },
  professional: {
    media: {
      src: `${URL_STATICS_IMAGES}market-player-professional@2x.jpg`,
      alt: 'publisher-professional'
    },
    text: {
      title: 'CARD_MARKET_PLAYERS_PROFESSIONAL_TITLE',
      description: 'CARD_MARKET_PLAYERS_PROFESSIONAL_TEXT'
    },
    link: PROFESSIONALS_PATH_PATTERN
  },
  secondHandBuyer: {
    media: {
      src: `${URL_STATICS_IMAGES}market-player-second-hand-buyer@2x.jpg`,
      alt: 'buyer'
    },
    text: {
      title: 'CARD_MARKET_PLAYERS_SECOND_HAND_BUYER_TITLE',
      description: 'CARD_MARKET_PLAYERS_SECOND_HAND_BUYER_TEXT'
    },
    link: SECOND_HAND_PATH_PATTERN
  }
}
